// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/dvirCoverage.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9886: a DVIR is owed per truck + driver + day.)
//
// Side-effect module: attaches `window.DvirCoverage`. dispatch.js (missing-DVIR
// badge + driver-PIN cards) reads it at CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  function _dvirStr(v) {
    return v === null || v === undefined ? '' : String(v).trim();
  }

  function _dvirNameKey(v) {
    return _dvirStr(v).toLowerCase().replace(/\s+/g, ' ');
  }

  // pretrips: [{ truckId, driverId, driverName, dayKey }] — dayKey is the
  // caller's YYYY-MM-DD for the day the DVIR counts toward. Returns a plain
  // object (serializable, cheap to rebuild on every snapshot).
  function buildDvirCoverage(pretrips) {
    var cov = {};
    (Array.isArray(pretrips) ? pretrips : []).forEach(function (p) {
      if (!p) return;
      var t = _dvirStr(p.truckId);
      var day = _dvirStr(p.dayKey);
      if (!t || !day) return;
      cov[t + '|truck|' + day] = true;
      var id = _dvirStr(p.driverId);
      var nm = _dvirNameKey(p.driverName);
      if (!id && !nm) { cov[t + '|*|' + day] = true; return; }
      if (id) cov[t + '|id:' + id + '|' + day] = true;
      if (nm) cov[t + '|name:' + nm + '|' + day] = true;
    });
    return cov;
  }

  // Truck-level: does ANY DVIR exist on this truck for the day?
  function dvirTruckHasAny(cov, truckId, dayKey) {
    return !!(cov && cov[_dvirStr(truckId) + '|truck|' + _dvirStr(dayKey)]);
  }

  // driver: { id, name } (either may be blank). True when THIS driver has a DVIR
  // on the truck for the day, or a driverless DVIR cleared the whole truck.
  function dvirDriverCovered(cov, truckId, dayKey, driver) {
    if (!cov) return false;
    var t = _dvirStr(truckId);
    var day = _dvirStr(dayKey);
    if (!t || !day) return false;
    if (cov[t + '|*|' + day]) return true;
    var id = _dvirStr(driver && driver.id);
    var nm = _dvirNameKey(driver && driver.name);
    if (id && cov[t + '|id:' + id + '|' + day]) return true;
    if (nm && cov[t + '|name:' + nm + '|' + day]) return true;
    return false;
  }

  // drivers: [{ id, name }] assigned to the truck that day. No drivers → the
  // truck-only answer. Otherwise EVERY driver needs their own DVIR (COD
  // 2026-10-15: multi-driver jobDay = each assigned driver owes one).
  function dvirTruckCovered(cov, truckId, dayKey, drivers) {
    var list = Array.isArray(drivers) ? drivers.filter(function (d) { return !!d; }) : [];
    if (list.length === 0) return dvirTruckHasAny(cov, truckId, dayKey);
    for (var i = 0; i < list.length; i++) {
      if (!dvirDriverCovered(cov, truckId, dayKey, list[i])) return false;
    }
    return true;
  }

  window.DvirCoverage = Object.freeze({
    build: buildDvirCoverage,
    truckHasAny: dvirTruckHasAny,
    driverCovered: dvirDriverCovered,
    truckCovered: dvirTruckCovered
  });
})();
